import { createRouter, createWebHistory } from 'vue-router';
import { getRotas, updateDynamicRoutes } from '@/router/routesManager';
import { usuarioTemPrivilegio, getSistemaSelecionado, setSistemaSelecionado } from '@/util';
import { getUsuarioToken } from '@/services/auth.service';
//import { getSistemas } from '@/services/sistemas.service';
import store from '@/store';

const setupRouter = async () => {
    const token = JSON.parse(localStorage.getItem('mizunetoken'));
    let usuario = store.state.usuario;
    if (token && !usuario) {
        try {
            usuario = await getUsuarioToken(token);
        } catch (error) {
            console.error('Erro ao obter dados do usuário:', error);
            localStorage.removeItem('mizunetoken');
        }

        if (!usuario) {
            localStorage.removeItem('mizunetoken');
        }

        if (usuario) {
            const isUsuarioMaster = usuario.authorities.some((a) => a.authority == 'MASTER');

            // TODO: Implementar alerta e redirecionamento para renovação de licença vencida
            // Por enquanto, permite login mesmo com licenças vencidas
            /*
            if (!isUsuarioMaster && (usuario.licencas == null || usuario.licencas == undefined || usuario.licencas.length == 0)) {
                localStorage.removeItem('mizunetoken');
            } else {
            */

            if (usuario.licencas && usuario.licencas.length > 0) {
                const cdsistema = getSistemaSelecionado();
                if (cdsistema) {
                    const temLicencaAtivaDoSistema = usuario.licencas.some((licenca) => licenca.cdsistema === cdsistema);
                    if (!temLicencaAtivaDoSistema && !isUsuarioMaster) {
                        setSistemaSelecionado(usuario.licencas[0].cdsistema);
                    }
                } else {
                    setSistemaSelecionado(usuario.licencas[0].cdsistema);
                }
            }
            // }
            store.commit('setUser', usuario);
        }
    }
    // Checar se tem sistemas na storage
    // let listaSistemas = store.state.sistemas;
    // if (!listaSistemas) {
    //     const retornoListaSistemas = await getSistemas();
    //     store.commit("setSistemas", retornoListaSistemas);
    // }
    const todasAsRotas = await getRotas();
    todasAsRotas[0].children.push({
        path: '/alterarsenha',
        name: 'alterarSenha',
        meta: {
            requireAuth: true,
        },
        component: () => import(`@/views/pdr/usuarios/usuariosAlterarSenha.vue`),
    });

    const router = createRouter({
        history: createWebHistory(),
        routes: todasAsRotas,
        scrollBehavior() {
            return { top: 0 }
        },
    });
    router.beforeEach(async (to, from, next) => {
        //console.log('Navegando para:', to.name);
        const token = JSON.parse(localStorage.getItem('mizunetoken'));
        //console.log('Token no beforeEach:', token);
        if (!token && to.meta.requireAuth && to.name != 'logoutPage' && to.name != 'loginPage') {
            // Salva o caminho de destino para redirecionar após o login
            next({
                name: 'loginPage',
                query: { redirect: to.fullPath }
            });
            //console.log('Redirecionando para login. Destino original:', to.fullPath);
            return;
        }
        const requerGrants = to.meta.grants && to.meta.grants.length > 0;
        if (requerGrants) {
            if (token && !usuarioTemPrivilegio(token, to.meta.grants)) {
                console.log('XXXX', token, to.meta.grants);
                next({ name: 'accessDenied' });
                return;
            }
        }
        next();
    });
    return router;
};

const router = await setupRouter();
//console.log('Todas as rotas:', router.getRoutes());
export default router;

// Expondo a função de atualização
export const refreshDynamicRoutes = async () => {
    await updateDynamicRoutes(router);
};